<template>
  <div v-loading="loading">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-form-item :label="$t('CMSProduct.name')" prop="cmsName" >
           <el-input v-model="cmsNameModel"></el-input>
         </el-form-item>
       </el-col>
       <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align:right">
         <el-row justify="end">
           <el-col>
             <el-checkbox size="small" class="m-10" v-model="publishedModel" :label="$t('CMSProduct.published')" border></el-checkbox>
           </el-col>
         </el-row>
       </el-col>
     </el-row>
     <el-row>
       <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
         <div v-if="!indChangeSlug">
           <span class="fs-14 m-10 pb-20">
             Slug URL:
           </span>
           <span class="fs-14 secondary-text">
             /{{slugModel}}
           </span>
           <el-button v-if="cmsName != null && cmsName != ''" type="text" icon="el-icon-edit" class="ml-10" @click="handleChangeSlug"/>
         </div>
          <el-form-item :label="$t('CMSProduct.slug')" prop="slug" v-else>
             <el-input v-model="slugModel"></el-input>
           </el-form-item>
       </el-col>
     </el-row>
     <el-row>
       <el-collapse v-model="languageTabs">
         <el-collapse-item v-for="l in cmsLanguages" :key="l.id" :title="getLanguageDescriptionLanguage(l.code)" :name="l.code">
           <quill-editor v-if="model.descriptions != null" v-model="model.descriptions[l.id].content" style="border:1px solid #EBEEF5;min-height:100px;"
             @change="handleDescriptionChange"
             ref="noteEditor"
             :options="editorOptions">
           </quill-editor>
         </el-collapse-item>
       </el-collapse>
     </el-row>
     <el-divider />
     <el-row :gutter="10">
       <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
         <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
           <el-form-item :label="$t('CMSProduct.web_site')">
             <el-input :placeholder="$t('products.enterURL')" v-model="webSiteModel">
               <template slot="prepend">Http://</template>
             </el-input>
           </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="showProductType">
             <el-form-item :label="$t('CMSProduct.product_type')" prop="type">
               <el-select
                   v-model="typeModel"
                   filterable
                   value-key="id"
                   @change="handleProductTypeChange"
                   :loading="productTypesLoading">
                   <el-option
                     v-for="item in productTypes"
                     :key="item.id"
                     :label="item.name[lang]"
                     :value="item">
                   </el-option>
                 </el-select>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="showProductType">
             <el-form-item :label="$t('CMSProduct.product_specific_type')" prop="specificType">
               <el-select
                   v-model="specificTypeModel"
                   filterable
                   :disabled="typeModel==null"
                   remote
                   value-key="id"
                   :loading="productTypesLoading">
                   <el-option
                     v-for="item in productSpecificTypesChoices"
                     :key="item.id"
                     :label="item.name[lang]"
                     :value="item">
                   </el-option>
                 </el-select>
              </el-form-item>
          </el-col>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="border-left">
           <el-form-item :label="$t('CMSProduct.logo_label')" class="pl-40">
             <br>
             <ImageUploadWidget v-if="imageModel==null && productGaleryType!=null" :typeId="productGaleryType.id" @select="v => handleGalerySelection(v, 'logo')"></ImageUploadWidget>

             <div class="item card-base card-alt text-center" v-if="imageModel!=null">
               <img v-lazy="logo" alt="card image" class="image">
             </div>
             <span v-if="imageModel!=null"><el-button type="text" @click="removeLogo">{{$t('CMSProduct.logo.remove')}}</el-button></span>

           </el-form-item>
        </el-col>
     </el-row>
     <el-divider />
     <el-row :gutter="10">
       <el-col v-for="(attributeType, key) in customAttributesObject" :key="key" :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
         <el-form-item :label="customAttributesObject[key][0].type.name">
           <el-select v-model="model.attributes[key]" multiple :placeholder="$t('common.select.placeholder')" @change="handleAttributeChange" value-key="id">
             <el-option
               v-for="a in customAttributesObject[key]"
               :key="a.id"
               :label="a.value[lang]"
               :value="a">
             </el-option>
           </el-select>
          </el-form-item>
       </el-col>
     </el-row>
     <el-divider><i class="el-icon-location-information"></i></el-divider>
     <el-row>
       <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl=24>
         <el-form-item>
           <span>{{$t('CMSProduct.origin')}}</span>
           <OriginsTable
            :origins="model.origins"
            @remove="removeOrigin"
            :append-to-body="true"
            @add="v=>addRegionToOriginsModel(v.country, v.region, v.city)"></OriginsTable>
         </el-form-item>
       </el-col>
     </el-row>
     <el-divider />
     <el-row>
       <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="$t('CMSProduct.provider')" prop="provider">
            <CMSProviderSelect
              :provider="model.provider"
              :active="true"
              @selected="handleChangeProvider"
            />
           </el-form-item>
       </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
         <el-form-item :label="$t('CMSProduct.alias_provider_name')">
           <el-input v-model="model.aliasName" :disabled="model.provider == null || model.provider.id == null" @change=" v=> handleChangeProvider(null, true)"></el-input>
         </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <h4>{{ $t('CMSProduct.relatedProducts') }}</h4>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <ProductSelect :product="selectedRelatedProduct" :type="1" :active="true" @selected="handleProductRelatedHandle"/>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-select
              filterable
              allow-create
              v-model="selectedRelatedTagProduct"
              :placeholder="$t('products.tags')"
              @change="handleTagRelatedHandle"
              value-key="id">
              <el-option
                v-for="item in listTags"
                :key="item.id"
                :label="item.code"
                :value="item">
              </el-option>
            </el-select>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-table
          :data="relatedProducts"
          stripe
          style="width: 100%">
          <el-table-column
            prop="name"
            label="Nom">
            <template slot-scope="scope" >
              <span v-if="scope.row.type === 'PRODUCT'">{{ scope.row.name }}</span>
              <el-tag v-else>{{ scope.row.name }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope" >
              <el-button size="mini" circle type="danger" @click="removeRelatedProduct(scope.$index)"><i class="mdi mdi-delete fs-15"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
   <el-divider />
   <el-row>
     <h4>{{ $t('CMSProduct.technicalSpecs') }}</h4>
     <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
       <!-- <el-card class="mt-10 mb-10"> -->
         <el-row>
           <el-col>
             <el-button :disabled="category == null" @click="addItem">{{$t('CMSProduct.add_new_item')}}</el-button>
           </el-col>
         </el-row>
         <el-row class="mt-20">
           <el-col>
             <el-tabs type="border-card" v-if="items!=null && items.length>0">
               <el-tab-pane v-for="item in items" :key="item.id" :label="item.releaseYear || '--'" :lazy="true">
                  <ProductItem :productItemId="item.id" @delete="handleProductItemDeletion" @edit="handleProductItemEdition" @duplicate="handleDuplicate"></ProductItem>
               </el-tab-pane>
             </el-tabs>
           </el-col>
         </el-row>
       <!-- </el-card> -->
     </el-col>
   </el-row>
   
     <CmsProductItemDrawer
       direction="ltr"
       :productId="id"
       :erpProduct="erpProduct"
       :productTypeId="typeModelId"
       :productItemId="productItemIdToEdit"
       :duplicateProductItemId="productItemIdToDuplicate"
       :visible="cmsProductItemDialogVisible"
       :galeryTypes="galeryTypes"
       @close="closeCmsProductItemDialog"
       @add="handleProductItemAdded"
       @update="handleProductItemUpdated" />

  </div>
</template>
<script>

import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex';
import cmsAPI from '@/services/API/cmsAPI'
import ImageUploadWidget from "@/views/pages/CMS/components/image-upload-widget"
import OriginsTable from '@/views/pages/CMS/components/origin-table'
import CmsProductItemDrawer from '@/views/pages/CMS/components/cms-product-item-drawer'
import ProductItem from '@/views/pages/CMS/components/product-item-specification'
import CMSProviderSelect from '@/views/pages/CMS/components/select-cms-provider'
import ProductSelect from '@/components/product/select-product'
import SystemAPI from '@/services/API/system'

export default {
  name: 'CMSViewEditor',
	props: {
    erpProduct: {
      type: Object,
      default: null
    },
    id: {
      type: Number,
      default: null
    },
    published: {
      type: Boolean,
      default: false
    },
    publishedDate: {
      type: String,
      default: null
    },
    cmsName: {
      type: String,
      default: null,
    },
    slug: {
      type: String,
      default: null
    },
    contents: {
      type: Array,
    },
    webSite: {
      type: String,
      default: null
    },
    category: {
      type: Object,
      default: null
    },
    specificCategory: {
      type: Object,
      default: null
    },
    image: {
      type: Object,
      default: null
    },
    attributes: {
      type: Array,
    },
    origins: {
      type: Array,
    },
    cmsProvider: {
      type: Object
    },
    relatedProducts: {
      type: Array,
    },
    showProductType: {
      type: Boolean,
      default: true
    }
	},
  data() {
    return {
      listTags : [],
      loading: false,
      indChangeSlug: false,
      languageTabs : "fr",
      model : {
        descriptions : null,
        attributes: [],
        origins: [],
        provider: null,
        aliasName: null,
      },
      selectedRelatedProduct: null,
      selectedRelatedTagProduct: null,
      items : [],
      productTypes: [],
      productTypesLoading: false,
      attributesList: [],
      attributesLoading: false,
      galeryTypes : [],
      productItemIdToEdit: null,
      productItemIdToDuplicate: null,
      cmsProductItemDialogVisible: false,
      providers: [],
      editorOptions: {
        placeholder:"Saisir du contenu...",
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike', 'link']
					]
				}
			},
    };
  },components: {
    ImageUploadWidget,
    OriginsTable,
    CmsProductItemDrawer,
    ProductItem,
    CMSProviderSelect,
    ProductSelect,
  },
  watch: {
    id: function(val) {
      this.fetchItems();
    },
    contents : function(val){
      this.initDescription();
    },
    origins : function(val){
      this.initOrigins();
    },
    attributes : function(val){
      this.initAttributes();
    },
    cmsProvider: function(val) {
      this.initProvider();
    }
  },
	methods: {
    fetchTags(){
      return SystemAPI.getTags('PRODUCT',true)
        .then(tags=>{
          this.listTags = tags;
        })
    },
    removeRelatedProduct (index) {
     
      let relatedProducts = this.relatedProducts;
      this.relatedProducts.splice(index, 1);

      this.$emit('update', { relatedProducts });
    },
    handleProductRelatedHandle (selectedProduct) {
      if (selectedProduct != null && selectedProduct != '') {
        this.selectedRelatedProduct = null;
        let relatedProducts = this.relatedProducts;
        relatedProducts.push({ product: { id: selectedProduct.id }, name: selectedProduct.name, type: 'PRODUCT' });
        this.$emit('update', { relatedProducts });
      }
      
    },
    handleTagRelatedHandle(selectedTag){
      if (selectedTag != null && selectedTag != '') {
        this.selectedRelatedTagProduct = null;
        let relatedProducts = this.relatedProducts;
        relatedProducts.push({tag: {id : selectedTag.id}, name: selectedTag.code,  type: 'TAG'});
        this.$emit('update', { relatedProducts });
      }
    },
    fetchItems(){
      if (this.id == null) {
        this.items = [];
        return null;
      }
      cmsAPI.fetchCMSProductItems({ productId: this.id })
        .then((productItems) => {
          this.items = productItems;
        })
    },
    formatDate(datetime, format = 'L') {
        return moment(datetime).format(format);
    },
    handleChangeProvider (provider, isAliasNameOnly = false) {
      const cmsProvider = { };
      if (isAliasNameOnly == true) {
        cmsProvider.id = _.get(this, 'model.provider.id');
        cmsProvider.name = _.get(this, 'model.provider.name');
      } else {
        this.model.provider = provider;
        cmsProvider.id = _.get(provider, 'id');
        cmsProvider.name = _.get(provider, 'name');
      }

      cmsProvider.aliasName = this.model.aliasName;
      this.$emit('update', { cmsProvider });
    },
    openCmsProductItemDialog(){
      this.cmsProductItemDialogVisible=true;
    },
    addItem(){
      this.openCmsProductItemDialog();
    },
    handleDuplicate(productItemId){
      this.productItemIdToDuplicate = productItemId;
      this.productItemIdToEdit = productItemId;
      this.openCmsProductItemDialog();
    },
    handleProductItemEdition(productItemId){
      this.productItemIdToEdit = productItemId;
      this.openCmsProductItemDialog();
    },
    handleProductItemDeletion(productItemIdDeleted){
      this.fetchItems();
    },
    handleProductItemUpdated(itemUpdated){
      this.fetchItems();
    },
    handleProductItemAdded(itemCreated){
      // On met a jour le produit pour y ajouter l'association du productItem au Produit
      this.fetchItems();
    },
    closeCmsProductItemDialog(){
      this.productItemIdToEdit = null;
      this.productItemIdToDuplicate = null;
      this.cmsProductItemDialogVisible=false;
    },
    addRegionToOriginsModel(country, region, city) {
      this.model.origins.push({country, region, city});
      this.$emit('update', { origins: this.model.origins });
    },
    removeOrigin(index){
      this.model.origins.splice(index,1);
      this.$emit('update', { origins: this.model.origins });
    },
    handleAttributeChange () {
      const attributes = [];
      _.forIn(this.model.attributes, cat => {
        _.forEach(cat, att => {
            attributes.push(att);
        })
      })
      this.$emit('update', { attributes })
    },
    handleGalerySelection(asset, usedFor){
      if(usedFor=='logo'){
        this.$emit('update', { image: asset[0]})
      }
    },
    removeLogo(){
      this.$emit('update', { image: null })
    },
    handleProductTypeChange () {
      this.$emit('update', { specificCategory: null })
    },
    fetchProductTypes (){
      this.productTypesLoading = true;
      return cmsAPI.fetchProductTypes()
        .then(specificTypes=>{
          this.productTypes = specificTypes;
          this.productTypesLoading = false;

        })
    },
    handleDescriptionChange () {
      const contents = [];
      _.forIn(this.model.descriptions, (value, key) => {
        contents.push({ id: value.id, languageId: parseInt(key), content: value.content });
      })
      this.$emit('update', { contents })
    },
    getLanguageDescriptionLanguage (languageCode) {
      return this.$i18n.t(`CMSProduct.description.${languageCode}`);
    },
    initProvider () {
      this.model.provider = this.cmsProvider;
      this.model.aliasName = _.get(this.cmsProvider, 'aliasName');
      if (this.cmsProvider != null) {
        this.providers = [];
        this.providers.push(this.cmsProvider);
      }
    },
    initDescription () {
      if (!_.isEmpty(this.contents)) {
        this.model.descriptions = {};
        _.forEach(this.contents, c => {
          if (this.model.descriptions[c.languageId] != null) {
            this.model.descriptions[c.languageId] = {id: null, content: ''};
          }
          this.model.descriptions[c.languageId] = {id: c.id, content: c.content};

        })
      } else {
        this.model.descriptions = {};
        _.forEach(this.cmsLanguages, (l) => {
          this.model.descriptions[l.id] = {id: null, content: ''};
        })
      }

    },
    initAttributes () {
      this.model.attributes = {};
      _.forEach(this.attributesList, a => {
        if (this.model.attributes[a.type.code] == null) {
          this.$set(this.model.attributes, a.type.code, []);
        }
      })
      _.forEach(this.attributes, (a) => {
        if (this.model.attributes[a.type.code] != null) {
          this.model.attributes[a.type.code].push(a);
        }

      })
    },
    initOrigins () {
      this.model.origins = this.origins;
    },
    initModel () {
      this.initDescription();
      this.initAttributes();
      this.initOrigins();
      this.initProvider();
    },
    handleChangeSlug () {
      this.indChangeSlug = true;
    },
    fetchCMSGalleryTypes(){
      return cmsAPI.fetchCMSGalleryTypes()
        .then(types=>{
          this.galeryTypes.push(...types);
        })
    },
    fetchCMSAttributes () {
      this.attributesLoading = true;
      return cmsAPI.fetchCMSAttributes()
        .then(attributes => {
          this.attributesList = attributes;
          this.attributesLoading = false;
        })
    },
    searchProviders(params) {

    },
    searchProvidersById (id) {
      return this.searchProvidersById({ id });
    },
    ...mapActions('controlData',['fetchLanguages']),
	},
	computed: {
    customAttributesObject() {
      let attributes = {};
      _.forEach(this.attributesList, a => {
        if (attributes[a.type.code] == null) attributes[a.type.code] = [];
        attributes[a.type.code].push(a);
      })
      return attributes;
    },
    productGaleryType(){
      return _.find(this.galeryTypes, t=>{return t.code=='PRODUCT'})
    },
    logo () {
      return _.get(this.imageModel, 'thumbnailLink');
    },
    productSpecificTypesChoices(){
      const productType = _.find(this.productTypes, p=> p.id === _.get(this.typeModel, 'id'));
      if (productType != null) {
        return productType.specifics
      }
      return [];
    },
    lang(){
      return this.$i18n.locale
    },
    cmsLanguages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    publishedModel : {
      set(published){
        this.$emit('update', { published })
      },
      get(){ return this.published; }
    },
    publishedDateModel : {
      set(published){
        this.$emit('update', { publishedDate })
      },
      get(){ return this.publishedDate; }
    },
    cmsNameModel : {
      set(cmsName){
        this.$emit('update', { cmsName })
      },
      get(){ return this.cmsName; }
    },
    slugModel : {
      set(slug){
        this.$emit('update', { slug })
      },
      get(){ return this.slug; }
    },
    webSiteModel: {
      set(webSite){
        this.$emit('update', { webSite })
      },
      get(){ return this.webSite; }
    },
    aliasNameModel: {
      set(aliasName){
        this.$emit('update', { aliasName })
      },
      get(){ return this.aliasName; }
    },
    typeModelId () {
      return _.get(this.typeModel, 'id');
    },
    specificTypeModelId () {
      return _.get(this.specificTypeModel, 'id');
    },
    typeModel: {
      set(category){
        this.$emit('update', { category })
      },
      get(){ return this.category; }
    },
    specificTypeModel: {
      set(specificCategory){
        this.$emit('update', { specificCategory })
      },
      get(){ return this.specificCategory; }
    },
    imageModel: {
      set(logo){
        this.$emit('update', { image })
      },
      get(){ return this.image; }
    },
    attributesModel: {
      set(attributes){
        this.$emit('update', { attributes })
      },
      get(){ return this.attributes; }
    },
    ...mapState('controlData',['languages']),
	},
  created () {
  
  },
  mounted () {
    this.loading = true;
    return Promise.all([
      this.fetchLanguages(),
      this.fetchProductTypes(),
      this.fetchCMSGalleryTypes(),
      this.fetchCMSAttributes(),
      this.fetchItems(),
      this.fetchTags(),
    ])
    .then(() => {
      this.initModel();
      this.loading = false;
    })
    .catch((err) => {
      this.loading = false;
    })
  },
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

.image {
  max-height:160px;
  width:auto !important;
}
.main{
  padding: 20px;
  //margin: 20px 0;
  margin-bottom: 20px;
  //border-radius: 5px;
  // opacity: .85;
  transition: all .25s;

  /* masonry */
  //display: inline-block;
  box-sizing: border-box;
  box-shadow: 0px 0px 0px 1px $text-color-accent;
  width:100%;

  line-height:normal;

  img {
    width: 100%;
    max-width: 100%;
  }
}

.item {
  padding: 20px;
  //margin: 20px 0;
  margin-bottom: 20px;
  //border-radius: 5px;
  // opacity: .85;
  transition: all .25s;

  /* masonry */
  //display: inline-block;
  box-sizing: border-box;
  box-shadow: 0px 0px 0px 1px $text-color-accent;
  width: 200px;
  line-height:normal;
  img {
    // width: 100%;
    // max-width: 100%;
  }

}
</style>
